import React from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import constant from '../../constant';
import { getStorage, onChange, setStorage, validateForm } from '../../utils';
import WithToastContext from '../../context/ToastContext';
import Loader from '../../component/common/Loader';
import { login, checkEmail, register } from '../../action/_AuthAction';
import Logo from './../../assets/img/logo.png'

type Step = 'email' | 'register' | 'login';

class ComponentName extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            step: 'email' as Step,
            email: { name: 'email', required: true, error: '', value: '', type: constant.fieldType.string },
            password: { name: 'password', required: false, error: '', value: '', type: constant.fieldType.string },
            confirmPassword: { name: 'confirmPassword', required: false, error: '', value: '', type: constant.fieldType.string },
            showLoader: false
        };
    }

    componentDidMount() {
        document.title = constant.component.login.title;
        $('body').css('background', '#fff');
        const version = getStorage(constant.key.version);
        const token = getStorage(constant.key.token);
        if (version !== constant.app.version) {
            setStorage(constant.key.version, constant.app.version);
            window.location.reload();
        }
        if (token) {
            window.location.href = constant.component.loanList.url;
        }
    }

    render() {
        const { step, email, password, confirmPassword, showLoader } = this.state;
        const isEmailOnly = step === 'email';
        const isRegister = step === 'register';
        const isLogin = step === 'login';

        return (
            <div className="container-fluid">
                {showLoader && <Loader />}
                <div className="row mt-5">
                    <div className="col-md-8 text-center mb-5" style={{ position: 'relative' }}>
                        <img src="/assets/img/Happy family jumping with huge piggybank.jpg" style={{ width: '80%' }} alt="" />
                        <div style={{ fontSize: '1.2rem', display: 'flex', justifyContent: 'space-evenly' }}>
                            <span>🔎 Track status of your loan in <b style={{ color: '#023c5b', borderBottom: '1px dashed' }}>Realtime</b></span>
                            <span>📄 View <b style={{ color: '#023c5b', borderBottom: '1px dashed' }}>Documents</b> submitted for Loan Approval</span>
                            <span>👋 Get in touch with <b style={{ color: '#023c5b', borderBottom: '1px dashed' }}>Team</b> working on your Loan</span>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="text-center mb-5">
                            <img src={Logo} className="w-50" alt="Capital Plus Residential" />
                        </div>
                        <div className="b-shadow p-4" style={{ border: '0.1px solid #eeefff' }}>
                            <div className="">
                                {/* <h5>{isEmailOnly ? 'Sign in' : isRegister ? 'Create account' : 'Sign in'}</h5> */}
                                <hr />
                                <form onSubmit={this.onSubmit}>
                                    {isEmailOnly && (
                                        <div className="mb-3">
                                            <label className="form-label">Email *</label>
                                            <input
                                                type="email"
                                                name={email.name}
                                                onChange={this.onChange}
                                                value={email.value}
                                                className={email.error.length === 0 ? 'form-control' : 'form-control is-invalid'}
                                            />
                                        </div>
                                    )}
                                    {isRegister && (
                                        <>
                                            <div className="mb-3">
                                                <label className="form-label">Password *</label>
                                                <input
                                                    type="password"
                                                    name={password.name}
                                                    onChange={this.onChange}
                                                    value={password.value}
                                                    className={password.error.length === 0 ? 'form-control' : 'form-control is-invalid'}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Confirm Password *</label>
                                                <input
                                                    type="password"
                                                    name={confirmPassword.name}
                                                    onChange={this.onChange}
                                                    value={confirmPassword.value}
                                                    className={confirmPassword.error.length === 0 ? 'form-control' : 'form-control is-invalid'}
                                                />
                                            </div>
                                        </>
                                    )}
                                    {isLogin && (
                                        <div className="mb-3">
                                            <label className="form-label">Password *
                                                <Link to={constant.component.forgotPassword.url} className="btn btn-link">Forgot Password ?</Link>
                                            </label>
                                            <input
                                                type="password"
                                                name={password.name}
                                                onChange={this.onChange}
                                                value={password.value}
                                                className={password.error.length === 0 ? 'form-control' : 'form-control is-invalid'}
                                            />
                                        </div>
                                    )}
                                    <div className="row mt-3 pt-3">
                                        <div className="col">
                                            {isEmailOnly ? (
                                                // <Link className="btn btn-link" to={constant.component.register.url}>New User / Register</Link>
                                                <></>
                                            ) : (
                                                <button type="button" className="btn btn-link" onClick={this.backToEmail}>Back</button>
                                            )}
                                        </div>
                                        <div className="col text-right">
                                            <button className="btn btn-primary px-5" type="submit">
                                                {isEmailOnly ? 'Next' : isRegister ? 'Register' : 'Sign in'}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="text-center mt-3">
                            Powered by <a href="https://capitalplusres.com" target="_blank" rel="noreferrer">Loan Tracker USA</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    backToEmail = () => {
        this.setState({
            step: 'email',
            password: { ...this.state.password, value: '', error: '', required: false },
            confirmPassword: { ...this.state.confirmPassword, value: '', error: '', required: false }
        });
    };

    onChange = (e: any) => {
        onChange(this, e.target.name, e.target.value);
    };

    onSubmit = (e: any) => {
        e.preventDefault();
        const { step, email, password, confirmPassword } = this.state;

        if (step === 'email') {
            if (!validateForm(this)) return;
            this.setState({ showLoader: true });
            checkEmail({ email: email.value }).then((res: any) => {
                this.setState({ showLoader: false });
                const result = res.result;
                const exists = result?.exists === true;
                const registered = result?.registered === true;

                if (res.error && !result) {
                    this.props.context.toast.error(res.error || 'Request failed');
                    return;
                }
                if (!exists || (result && result.exists === false)) {
                    this.props.context.toast.error(`
                        Your email doesn't exist.
                        If you think this is an error, please us at ph@pccreativeny.com.
                        `);
                    return;
                }
                if (exists && !registered) {
                    this.setState({
                        step: 'register',
                        password: { ...this.state.password, required: true, value: '', error: '' },
                        confirmPassword: { ...this.state.confirmPassword, required: true, value: '', error: '' }
                    });
                    return;
                }
                if (exists && registered) {
                    this.setState({
                        step: 'login',
                        password: { ...this.state.password, required: true, value: '', error: '' }
                    });
                }
            });
            return;
        }

        if (step === 'register') {
            if (!validateForm(this)) return;
            if (password.value !== confirmPassword.value) {
                this.setState({ confirmPassword: { ...confirmPassword, error: 'Passwords do not match' } });
                return;
            }
            this.setState({ showLoader: true });
            register({ email: email.value, newPassword: password.value, confirmPassword: confirmPassword.value }).then((res: any) => {
                this.setState({ showLoader: false });
                if (res.error) this.props.context.toast.error(res.error);
                else {
                    this.props.context.toast.success('Account created. Please sign in.');
                    this.setState({
                        step: 'email',
                        password: { ...this.state.password, value: '', error: '', required: false },
                        confirmPassword: { ...this.state.confirmPassword, value: '', error: '', required: false }
                    });
                }
            });
            return;
        }

        if (step === 'login') {
            if (!validateForm(this)) return;
            this.setState({ showLoader: true });
            login({ email: email.value, password: password.value }).then((res: any) => {
                this.setState({ showLoader: false });
                if (res.error) this.props.context.toast.error(res.error);
                else window.location.href = constant.component.loanList.url;
            });
        }
    };
}

export default WithToastContext(withRouter(ComponentName));
